import xw from 'xwind';
import styled from '@emotion/styled';

const Title = styled.h2(
  xw`text-2xl sm:text-4xl text-black leading-none sm:leading-none text-center font-pangram font-bold`,
);

export default Title;
